import axiosInstance from './axiosInstance';

export const getUserProfileApi = () => {
  return axiosInstance
    .get('/user/get-profile')
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching user profile:', error);
      throw error;
    });
};

export const createUserApi = (payload) => {
  return axiosInstance
    .post('/user/create-user', payload)
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating user:', error);
      throw error;
    });
};

export const editUserApi = async (payload) => {
  return axiosInstance
    .post('/user/update-user', payload)
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating user:', error);
      throw error;
    });
};

export const getAllUsersApi = ({ page, pageSize }) => {
  return axiosInstance
    .get('/user/get-all-users', {
      params: {
        page,
        pageSize,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching all users:', error);
      throw error;
    });
};

export const deleteUserApi = (id) => {
  return axiosInstance.post('/user/delete-user', {
    userId: id,
  });
};
